import React from "react"
import * as styles from "./container.module.scss"

const Container = ({children, isHero, style}) => {
    return (
        <div className={`${styles.container} container`}>
            {children}
        </div>
    )
}

export default Container